import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function FirstStepsIllustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3904" data-mp="13lb97cx8080i">
      
      <div className="relative w-full h-full bg-gradient-to-b from-sky-200 to-sky-50" data-id="element-3905" data-mp="1hgnf8ggttkwq">
        {/* Background: Sun and Clouds */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3906" data-mp="1rdia8pdw5369">
          
          <circle cx="160" cy="40" r="20" fill="#FDE047" data-id="element-3907" data-mp="1mef7xcpapb1z" />
          <path d="M40 60 Q50 40 70 50 Q90 40 100 60 Q110 70 90 80 L50 80 Q30 70 40 60 Z" fill="white" fillOpacity="0.8" data-id="element-3908" data-mp="3t3tssdte725a" />
          
        </svg>

        {/* Background: Hill */}
        <svg className="absolute bottom-0 left-0 w-full h-1/2 z-0" viewBox="0 0 200 100" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-3909" data-mp="1ksjl1ay7iiwe">
          
          <path d="M0 50 Q100 -20 200 50 L200 100 L0 100 Z" fill="#86EFAC" data-id="element-3910" data-mp="1pp9x7n6w4ucj" />
          <path d="M0 60 Q100 0 200 60 L200 100 L0 100 Z" fill="#4ADE80" data-id="element-3911" data-mp="1tretyusmy73e" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[10%]" data-id="element-3912" data-mp="1ykzhtu0ilkov">
          <div className="w-[60%] h-[60%] flex items-center justify-center" data-id="element-3913" data-mp="23i9cbo2rgmjk">
            <DjaySpecimen look={{
            variant,
            accessory: 'seedling'
          }} size="hero" emotion={isUnlocked ? 'happy' : 'sleeping'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3914" data-mp="28gt3c2w7oois" />
            
          </div>
        </div>

        {/* Foreground: Extra grass/dirt */}
        <svg className="absolute bottom-0 left-0 w-full h-1/4 z-20" viewBox="0 0 200 50" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3915" data-mp="j493t93hzfx6">
          
          <path d="M80 40 L85 25 L90 40 Z" fill="#22C55E" data-id="element-3916" data-mp="1qff76n0cx2c8" />
          <path d="M120 45 L123 30 L126 45 Z" fill="#22C55E" data-id="element-3917" data-mp="1qfypw5xtzurb" />
          <ellipse cx="100" cy="45" rx="30" ry="5" fill="#A16207" fillOpacity="0.3" data-id="element-3918" data-mp="1lgvhqcmk18f4" />
          
        </svg>
      </div>
    </DjayIllustrationBase>;
}